import React from 'react';
import { Badge, Card, CardBody, CardText, CardTitle } from 'reactstrap';
import i18n from '@/utils/i18n';
import { AllEventsFragmentFragment } from '../../../graphql/fragments/allEventsFragement.generated';
import { getImageUrl } from '@/utils/imageUrl';

type EventCardProps = {
  event: AllEventsFragmentFragment;
  children: React.ReactElement;
};

const EventCard = ({ event, children }: EventCardProps) => {
  const isOngoing =
    event.start_date &&
    event.end_date &&
    new Date(event.start_date) <= new Date() &&
    new Date(event.end_date) >= new Date();

  return (
    <Card
      key={event.id}
      style={{ cursor: 'pointer', width: 280 }}
      className="overflow-hidden"
      onClick={() =>
        document.getElementById(`view-details-button_${event.id}`)?.click()
      }
    >
      {/* Image */}
      <div
        className="event-card-image"
        style={{
          backgroundImage: `url(${getImageUrl(300, event.image_url)})`,
        }}
      >
        {/* Ongoing badge */}
        {isOngoing && (
          <Badge color="success" className="m-3 border border-1" pill>
            {i18n.t('EventsDashboard:ongoing')}
          </Badge>
        )}
      </div>

      <CardBody>
        <CardTitle className="mb-0">{event.name}</CardTitle>

        {/* Event period */}
        {event.start_date && event.end_date && (
          <CardText>
            <small className="text-muted">
              {new Date(event.start_date).toLocaleDateString()} -{' '}
              {new Date(event.end_date).toLocaleDateString()}
            </small>
          </CardText>
        )}

        {children}
      </CardBody>
    </Card>
  );
};

export default EventCard;
